module.exports = __webpack_public_path__ + "static/img/place_1.8169518c.png";